<template>
  <div class="slider">
    <div class="mask">
      <div class="container">
        <div class="title">
          <div class="text">
            <span>拼图验证</span>
          </div>
          <div class="button-group">
            <span class="refresh" @click="reset">
              <i class="el-icon-refresh"></i>
              <span>换一张</span>
            </span>
            <span @click="close" class="iconClose">
              <i class="el-icon-close"></i>
            </span>
            <!--            <img-->
            <!--              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE2UlEQVRoQ+1YXWwUVRT+zsw2Qktn1ljatEjjD+4WJILpg0rE4ItGn0QMyGMTE/kJTUwFElt2ZmopQWhIMNjyRKIPiH/hScXEiJEgL/4mamcwUSG2UCvuzAJt7e4cc6ddFaTMHTq70qTztnvPPef7zt899xJm+EczHD9mCfzfEZyNQNwRaD7IFSPnLy/FbZWnv99MF8P033QRSFvuDmbuJOBL20w2zzwCpnuEwWtnLIGU6X4O8IMEHLXN5OqyRcBgVg7vzK1AwX+KGM0ANQDcwAQVwAVi+oWAU6Ti46Vp7djba6lwLXBp0/2VwQ0getUx9NaSE1h1iOcMns21ss9tANeGGRTrBDrHCnrnzNV6vt1Kl4p7RAHnBr1RgBVFUbb2Z7S9YfqmVcRNVm6Nj8I+MBYGwAiXmHFMIXzkg85UkDpQQD7BwN0M3AWfloGwGsy3FIlARYu9Q/9Q/G7aNXKHPzb2U7CmYJ2dSb5VEgLMTGkr1wX4LwUGiM4T2Kpv1A8db6HR6xm9vzs3f2S88JwPbAZjAYgKBN5iG8nexV25Rwr5wqdiv5qgh37o0E/FTkCAb+r0DjPzukkv9qnzta0yPfvfYB7Yz9ofF9xDAJ4W/ytE+3wVXyHPrwd651YssLdXDcROIGV6O4XnCZQHcavw3PWMLOn0VvrghUQ8xJw4n1AxtPiequFiETdZXpsP3g1mlUAnGbyCiMafzWhzLCI/VgJBznPhncl83xQGvvkgV14852WZueJKIOSD8DuAIYIgRrcCvLwoQ8DPtpm8Mwz8RAZIfqLbDJxxHVGwBOqzTX2jzNa06R5gQjNNdKhaZlSF76MTjqmvDJeLQCDd6W1j398tCjZRoy2KmvNFMPft4aqx0dFahf6s85kEoVpivw5Mt4v0AagSRH2OofXERiA4pCxvUPR5IoSmjozhuGSkUijV5T2MvP+Z6PP1jXpNWKuMC5yMHjkCVnYvGG0A3nPM5BoZxeWSkSKQNrOfMLBKIWzoN5IHywVOxo4kAddmcApETzqG/oGM4huVEfX2puVZTHAcQ38jTI8kgWyOgXkVSmL5d5l534Qpnc76vbvcReNjfJqAy7aZDG25Nx+BzovLxv3810TI2UZSC3OGJIHypVDKcp8A8/sEcmxTT8dEoHxF3GRln/cZfQQct83ko7EQSJWxjabM7LvBhErocYzki/EQKNNBFtzuzrjDwbyUUFY6HdqJWAiUa5RIW9mNzHgNoKH1hlYf6zgd1zA3lUeXHOB5+WHvRzDXkaJstzPaK2Hev/FxmqjXNvRNMgZkZdKm28vgDSCcbWjUU7LzllQbLYK44kKjYKOdSfbJArye3D+pI66W6jP9RrUoZKkvEgGhMW25XczcHlwpFd4yXRICPJj2MzgBKN2OqbVLIZ8UikzgP5d6ol61RtsW9YIjcr7wm7cnSJvgYYOO9Ge09UTEJSUglE+SeFlEIjAW4VllslW2MMgQBTsBVum2jeqOqOAjFfG1vCLzsCX2jXOhQQE3+ozHiPD43/diwlkF6gtRcv5qHJFT6GoFN/K0KPo8KdRTv7B6v2y3mSqtpk2gqHiqx92JdRoAeIAJX0BVjq5vrz4pc0jJ1EJsBGSMlUJmlkApvBpF52wEonirFLKzESiFV6PonI1AFG+VQvYvqQFST/EC5cgAAAAASUVORK5CYII="-->
            <!--              @click="reset"-->
            <!--            />-->
            <!--            <img-->
            <!--              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB3klEQVRoQ+2Yy0oEMRBFz/hABf0Gda2gO9349W50p6Br9RsUVHxS0JEwZCaV5EZp7IFedbpyT91KUpMZI//NRq6fCeCvHZwcmBxozMC/KqFV4BP4akya53Ob68Mz0OvAPrALvAA3wJMneMWYbeAQ2AQegLtcDA+AZeMsCvQGXHeAMPFHwHo013nOCQ+AjTkZshJiqyFS4s3ty1zJegBMtE1wDKxF2XkHrgROpMRbbHP5UVFCIUYPiCbxJszrQA+IZvE1AKpyWuSmq2zisip1QOGETHytAy0Q8nVU60AOIlUKcvGtDpRA7AyHlHwbbnUghpg/RcNebmPsnVy8yoEchL3vIl4NELbYeSfiXU91ev/EVJVQLDJ1QNl7ufgeDljM1IINAMUHlbIXysVaJj58627SPJOpHUhl3tpu+8U9vhRCtQYWibeSCdtoFwgFwDLx4a+npPNMlVUrgEd87pxoWtgtACXiu0HUAtSI7wJRA9AiXg5RCqAQL4UoAVCKl0F4AXqIl0B4AGzMKbAR7cO/cbH1ClwoLrZGf7Void8bnmfgVnAbt6hXsxP7ANgC7odnaV/nKaEQYGW4Xvc2ii3j3HOVALQI6vbtBNAttc7AkwPORHUbNjnQLbXOwKN34BvKiqMxJwSPZAAAAABJRU5ErkJggg=="-->
            <!--              @click="close"-->
            <!--            />-->
          </div>
        </div>
        <div class="img">
          <div class="backgroup-img">
            <img class="inner-bg-img" :src="backgroupImg" v-if="backgroupImg" />
          </div>
          <div
            class="move-img"
            :style="{ left: `${moveX}px`, top: `${moveTop}px` }"
          >
            <img class="inner-mv-img" :src="moveImg" v-if="backgroupImg" />
          </div>
        </div>
        <div class="slide" id="dragContainer">
          <div
            class="slider-mask"
            :style="{
              width:
                blcokLeft > 26
                  ? Number(`${blcokLeft}`) + 40 + 'px'
                  : `${blcokLeft}px`
            }"
          >
            <!--       style="width:360px;"     -->
            <div
              class="slider-mask-left"
              :class="errorFlag ? 'slider-mask-left-errorleft' : ''"
            ></div>
            <div
              class="slider-mask-center"
              :class="errorFlag ? 'slider-mask-left-errorcenter' : ''"
            ></div>
            <div
              class="slider-mask-right"
              :class="errorFlag ? 'slider-mask-left-errorright' : ''"
              :style="{
                display: errorFlag ? 'none' : blcokLeft > 26 ? 'block' : 'none'
              }"
            ></div>
          </div>
          <div
            id="dragHandler"
            class="block"
            :class="errorFlag ? 'blockerror' : ''"
            ref="block"
            @mousedown="start"
            :style="{ left: `${blcokLeft}px` }"
          >
            <!--      style="left:324px;"        -->
          </div>
        </div>
        <div class="loading" v-if="loading">
          <span>拼图加载中...</span>
        </div>
        <div class="loading" v-if="errorFlag">
          <div
            class="icon-ccui-cancel"
            style="margin-bottom:10px;cursor:pointer"
            @click="errorFlag = false"
          ></div>
          <span>{{ errorFlagMsg }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// =========================================
// 父组件需要提供的方法 名称
// =========================================

/**
 * 获取滑块图片方法
 */
const GET_IMG_FUN = "getImg";
/**
 * 校验滑块图片方法
 */
const VALID_IMG_FUN = "validImg";
/**
 * 滑块窗口关闭事件监听
 */
const CLOST_EVENT_FUN = "close";

export default {
  data() {
    return {
      /**滑块背景图片 */
      backgroupImg: "",
      /**滑块图片 */
      moveImg: "",
      /**是否已经移动滑块 */
      startMove: false,
      /**滑块移动距离 */
      blcokLeft: 0,
      /**开始滑动的x轴 */
      startX: 0,
      /**划过的百分比 */
      movePercent: 0,
      /**验证码唯一ID */
      uuid: "",
      /**滑块移动的x轴 */
      moveX: 0,
      /** 加载遮罩标识 */
      loading: false,
      errorFlag: false,
      errorFlagMsg: "",
      /** 滑块Y轴*/
      moveTop: 0
    };
  },
  props: {
    // 是否开启日志， 默认true
    log: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mounted() {
    this.getImg();
  },
  methods: {
    /**
     * 打印日志
     */
    printLog(msg, ...optionalParams) {
      if (this.log) {
        if (optionalParams && optionalParams.length > 0) {
          console.info(
            `滑块验证码[${msg}]`,
            optionalParams.length === 1 ? optionalParams[0] : optionalParams
          );
        } else {
          console.info(`滑块验证码[${msg}]`);
        }
      }
    },

    /**
     * 获取滑块图片
     */
    getImg() {
      this.loading = true;
      this.$emit(GET_IMG_FUN, data => {
        this.printLog(GET_IMG_FUN, data);
        this.loading = false;
        if (!data) return;
        console.log("data", data);
        if (data.code == "0") {
          this.backgroupImg = `data:image/png;base64,${data.data.bigImagel}`;
          this.moveImg = `data:image/png;base64,${data.data.imagel}`;
          this.uuid = data.data.uuid;
          this.moveTop = data.data.width;
        } else {
          this.errorFlag = true;
          this.errorFlagMsg = data.message;
        }
      });
    },
    /**
     * 校验图片
     */
    validImg() {
      this.printLog(`滑块抬起`, this.movePercent);
      this.$emit(VALID_IMG_FUN, this.blcokLeft, this.uuid, data => {
        this.printLog(VALID_IMG_FUN, data);
        if (data.data === false) {
          this.errorFlag = true;
          this.errorFlagMsg = data.message;
          setTimeout(() => {
            this.reset();
          }, 500);
        }
      });
    },
    /**
     * 重新生成图片
     */
    reset() {
      this.getImg();
      this.errorFlag = false;
      this.moveX = 0;
      this.movePercent = 0;
      this.startX = 0;
      this.blcokLeft = 0;
    },
    /**
     * 按钮关闭事件
     */
    close() {
      this.printLog("关闭按钮触发");
      this.$emit(CLOST_EVENT_FUN);
    },
    /**
     * 开始滑动
     */
    start(e) {
      this.startX = e.pageX;
      this.startMove = true;
      window.addEventListener("mousemove", this.move);
      window.addEventListener("mouseup", this.up);
    },
    /**
     * 滑块滑动事件
     */
    move(e) {
      console.log(this.startMove);
      if (!this.startMove) return;
      const moveX = e.pageX - this.startX;
      const movePercent = moveX / 360;
      if (moveX <= 0) {
        this.blcokLeft = 0;
        this.moveX = 0;
        this.movePercent = 0;
      } else if (moveX >= 0 && moveX <= 305) {
        this.blcokLeft = moveX;
        this.moveX = moveX;
        this.movePercent = movePercent;
      } else if (moveX > 305 && moveX < 324) {
        this.blcokLeft = moveX;
        this.moveX = 305;
        this.movePercent = movePercent;
      }
      console.log(this.blcokLeft);
    },
    /**
     * 滑块鼠标抬起事件
     */
    up(e) {
      console.log(e);
      window.removeEventListener("mousemove", this.move);
      window.removeEventListener("mouseup", this.up);
      if (!this.startMove) return;
      this.startMove = false;
      this.validImg();
    }
  },
  /**
   * 销毁事件
   */
  beforeDestroy() {
    window.removeEventListener("mousemove", this.move);
    window.removeEventListener("mouseup", this.up);
  }
};
</script>

<style lang="scss" scoped>
.slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 42px;
  //border: 0 solid #0089EF;
  //background: #0089EF;
  //border-radius: 23px 0 0 23px;
  transition: background 0.4s ease;
  .slider-mask-left {
    background: url("./images/sliderleft.png") no-repeat;
    width: 26px;
    height: 42px;
    float: left;
  }
  .slider-mask-left-errorleft {
    background: url("./images/slidererrleft.png") no-repeat;
    background-size: 100%;
    transition: background-position 0.5s;
  }
  .slider-mask-center {
    background: url("./images/slidercenter.png");
    margin-left: 24px;
    margin-right: 25px;
    color: #fff;
    height: 42px;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .slider-mask-left-errorcenter {
    background-size: 100%;
    background: url("./images/slidererrcenter.png");
    transition: background-position 0.5s;
  }

  .slider-mask-right {
    background: url("./images/sliderright.png") no-repeat;
    display: none;
    width: 26px;
    height: 42px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .slider-mask-errorright {
    background-size: 100%;
    background: url("./images/slidererrright.png") no-repeat;
    transition: background-position 0.5s;
  }
}
//.yidun_slider_icon {
//  //font-size:28px;
//  position: absolute;
//  //top: 50%;
//  margin-top: -6px;
//  left:0;
//  margin-left: -6px;
//  width:55px;
//  height:55px;
//  //color:#4A4A4A;
//  background-image: url('./images/slider.png');
//  background-position: 0 -13px;
//  background-size: 32px 544px;
//}
.inner-mv-img,
.inner-bg-img,
.title {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.slider {
  width: 100%;
  height: 100%;
  .mask {
    display: block;
    z-index: 998;
    background: rgba(0, 0, 0, 0);
    width: 100%;
    height: 100%;
  }
  .container {
    position: absolute;
    z-index: 999;
    width: 400px;
    height: 265px;
    margin: auto;
    background: rgba(255, 255, 255, 1);
    //border-radius: 4px;
    ////box-shadow: 0px 4px 6px 0px rgba(201,201,201,0.5), 4px 0px 4px 0px rgba(229,229,229,0.5);
    //box-sizing: border-box;
    //padding: 17px 15px;
    .title {
      font-size: 14px;
      color: #333;
      display: flex;
      justify-content: space-between;
      padding: 10px 20px 10px;

      .button-group {
        img {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
    }

    .text {
      font-size: 13px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4a4a4a;
      margin-left: 0;
    }

    .img {
      width: 360px;
      height: 140px;
      position: relative;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }

      .backgroup-img {
        //position: absolute;
        //left: 0;
        //top: 0;
        width: 360px;
        height: 140px;
      }

      .move-img {
        //width: 52.20338981px;
        width: 55px;
        height: 45px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .slide {
      width: 358px;
      height: 44px;
      background: #f2f2f2;
      border-radius: 23px;
      border: 1px solid #cacaca;
      box-sizing: border-box;
      position: relative;
      margin: 0 auto;
      margin-top: 10px;

      &::before {
        position: absolute;
        content: "向右滑动完成拼图";
        display: flex;
        //justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #4a4a4a;
        width: 100%;
        height: 100%;
        text-indent: 64px;
      }

      .block {
        margin-top: -5px;
        margin-left: -5px;
        width: 55px;
        height: 55px;
        border-radius: 50%;
        position: absolute;
        top: 0;
        cursor: pointer;
        background-image: url("./images/slider.png");
        //background-repeat: no-repeat;
        background-size: 100%;
      }
      //.blockerror{
      //  animation: move 600ms linear infinite;
      //  animation-fill-mode : forwards;
      //}
      //@keyframes move {
      //  to {
      //    left: 0px;
      //  }
      //}
    }

    .loading {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 0;
      left: 0;
      //border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      flex-direction: column;
    }

    .refresh {
      cursor: pointer;
      .el-icon-refresh {
        font-size: 15px;
        color: #0089ef;
        margin-right: 6px;
      }

      span {
        font-size: 13px;
        color: #0089ef;
      }
    }

    .iconClose {
      margin-left: 10px;
      cursor: pointer;
      .el-icon-close {
        font-size: 16px;
        color: #cccccc;
      }
    }
  }
}
</style>
